




import { Component , Vue } from 'vue-property-decorator';
@Component({
    props: {
        placeholder: String,
        minDate: Date,
        maxDate: Date,
    },
})
export default class DatePicker extends Vue {}
